import useSchedulesManager from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useSchedulesManager.ts";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData.ts";
import type { ImportAction } from "@/pages/human-resources/time-management/components/schedule-import/model/ImportAction.ts";
import useVisibleEmployeesSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleEmployeesSchedules.ts";
import useScheduleDataStateDispatch from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useScheduleDataStateDispatch.ts";
import showErrorToast from "@/shared/components/generic/snackbar/showErrorToast.ts";
import { useTranslation } from "react-i18next";
import { copyDaySchedule } from "@/pages/human-resources/time-management/endpoints/schedules-copy/SchedulesCopyEndpoints.ts";

export default function useImportDaySchedule(): (
  action: ImportAction,
  dayToImport: Date,
) => Promise<void> {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  const refData = useScheduleReferenceData();
  const dataStateDispatch = useScheduleDataStateDispatch();
  const visibleSchedules = useVisibleEmployeesSchedules();
  const {
    contractsManager: { startDate: scheduleDate },
  } = useSchedulesManager();

  return async (action: ImportAction, dayToImport: Date): Promise<void> => {
    const overwrite = action === "overwrite";
    const employeesIds = visibleSchedules.map((es) => es.employee.id);
    dataStateDispatch({
      type: "employeesMarkStale",
      employeesIds,
    });
    try {
      await copyDaySchedule({
        siteId: parseInt(refData.siteData.siteId),
        overwrite,
        employeesIds: employeesIds.map((id) => parseInt(id)),
        sourceDate: dayToImport.toISOString(),
        targetDate: scheduleDate.toISOString(),
      });
    } catch (error) {
      console.error("Failed to import schedules", error);
      showErrorToast(t("errors.backend.schedules.import"));
    }
    dataStateDispatch({ type: "schedulesMarkStale" });
  };
}
